/*
  Generic tab switcher for [data-pf-tabs] roots that contain role=tab
  buttons and role=tabpanel panels (landing hero featured switcher, etc.).
  No autoplay. Arrow keys, Home and End move between tabs. Re-runs on
  shopify:section:load for the theme editor.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pfTabsReady) return;
    root.dataset.pfTabsReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
        if (n === null) return;
        e.preventDefault();
        select((n + tabs.length) % tabs.length, true);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-pf-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
